import "./Modal.css";
import React from "react";
import { X } from "lucide-react";
import PaymentSheetForm from "./PaymentSheetForm";

interface PaymentSheetModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PaymentSheetModal: React.FC<PaymentSheetModalProps> = ({
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-container modal-large"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2>Generate Payment Sheet</h2>
          <button className="modal-close" onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        <div className="modal-body">
          <PaymentSheetForm />
        </div>
      </div>
    </div>
  );
};

export default PaymentSheetModal;
